<template>
  <Input :value="value" @input="onInput" :type="inputType" v-bind="$props">
    <template v-slot:rightIcons>
      <Icon
        :name="iconName"
        :handleClick="toggleVisible"
        class="icon-password"
      />
    </template>
  </Input>
</template>

<script>
import Icon from '../Icon/Icon.vue';
import Input from '../Input/Input.vue';

export default {
  components: { Icon, Input },
  name: 'InputPassword',
  props: {
    id: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    errorMessage: {
      type: String,
    },
    infoMessage: {
      type: String,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    iconName() {
      if (this.visible) {
        return 'eye';
      }
      return 'eye-close';
    },
    inputType() {
      if (this.visible) {
        return 'text';
      }
      return 'password';
    },
  },
  methods: {
    toggleVisible() {
      if (this.disabled) {
        return false;
      }
      this.visible = !this.visible;
    },
    onInput(value) {
      this.$emit('input', value);
    },
  },
};
</script>
<style scoped lang="scss">
.icon-password {
  fill: var(--track-color-bluegray-50);
  &:hover {
    fill: var(--track-color-bluegray-50);
  }
}
</style>
